module.exports = __webpack_public_path__ + "static/media/MICH2.6c924e12.png";